import "../foundation/ctl-button.js";
import "../forms/ctl-text-field.js";
import "../forms/ctl-select.js";
import "../forms/ctl-form-field.js";
import "../layouts/ctl-inline.js";
import "../foundation/ctl-typography.js";
import "../data-display/ctl-tag.js";

const template = document.createElement("template");

template.innerHTML = `
<style>
  :host{
    --ctl-font: var(--ctl-sf-font, var(--ctl-font-sans));
    --ctl-text: var(--ctl-sf-text, var(--ctl-color-text));
    --ctl-muted: var(--ctl-sf-muted, var(--ctl-color-muted));
    --ctl-border: var(--ctl-sf-border, var(--ctl-color-border));
    --ctl-surface: var(--ctl-sf-surface, var(--ctl-color-surface));
    --ctl-brand: var(--ctl-sf-brand, var(--ctl-color-brand));
    --ctl-radius: var(--ctl-sf-radius, var(--ctl-radius-lg));
    --ctl-shadow: var(--ctl-sf-shadow, var(--ctl-shadow-sm));

    display:block;
    font-family: var(--ctl-font);
    color: var(--ctl-text);
  }

  .card{
    border: 1px solid var(--ctl-border);
    background: var(--ctl-surface);
    border-radius: var(--ctl-radius);
    box-shadow: var(--ctl-shadow);
    overflow:hidden;
  }

  .head{
    padding: var(--ctl-space-3-5) var(--ctl-space-3-5) 0;
  }
  .title{
    font-weight: var(--ctl-font-weight-black);
    letter-spacing: -0.01em;
    margin: 0;
    line-height: 1.15;
    font-size: var(--ctl-font-size-base);
  }
  .sub{
    margin: var(--ctl-space-1-5) 0 0;
    color: var(--ctl-muted);
    font-size: var(--ctl-font-size-md);
    line-height: 1.4;
  }

  form{
    padding: var(--ctl-space-3-5);
    display:grid;
    gap: var(--ctl-space-3);
  }

  .grid{
    display:grid;
    grid-template-columns: 1.2fr 0.9fr 0.9fr;
    gap: var(--ctl-space-3);
    align-items:end;
  }

  .row{
    display:flex;
    gap: var(--ctl-space-2-5);
    flex-wrap: wrap;
    align-items:center;
  }

  .toggles{
    display:flex;
    gap: var(--ctl-space-2);
    flex-wrap: wrap;
    align-items:center;
  }

  .toggle{
    display:inline-flex;
    align-items:center;
    gap: var(--ctl-space-2);
    padding: var(--ctl-space-2) var(--ctl-space-2-5);
    border-radius: var(--ctl-radius-full);
    border: 1px solid var(--ctl-border);
    background: color-mix(in srgb, var(--ctl-surface) 92%, var(--ctl-color-black) 8%);
    font-size: var(--ctl-font-size-md);
    cursor: pointer;
    user-select: none;
  }
  .toggle input{ width: var(--ctl-space-4); height: var(--ctl-space-4); accent-color: var(--ctl-brand); }

  .actions{
    display:flex;
    gap: var(--ctl-space-2-5);
    align-items:center;
    justify-content:flex-end;
    flex-wrap: wrap;
  }

  .helper{
    color: var(--ctl-muted);
    font-size: var(--ctl-font-size-sm);
    line-height: 1.35;
  }

  .errors{
    display:none;
    gap: var(--ctl-space-2);
    flex-wrap: wrap;
  }
  :host([invalid]) .errors{ display:flex; }
  .error{
    display:inline-flex;
    gap: var(--ctl-space-2);
    align-items:center;
    padding: var(--ctl-space-1-5) var(--ctl-space-2-5);
    border-radius: var(--ctl-radius-full);
    background: color-mix(in srgb, var(--ctl-color-danger) 8%, var(--ctl-color-surface));
    border: 1px solid color-mix(in srgb, var(--ctl-color-danger) 20%, var(--ctl-color-surface));
    color: color-mix(in srgb, var(--ctl-color-danger) 85%, var(--ctl-color-black));
    font-size: var(--ctl-font-size-sm);
    font-weight: var(--ctl-font-weight-bold);
  }

  .foot{
    padding: 0 var(--ctl-space-3-5) var(--ctl-space-3-5);
  }

  /* responsive */
  @media (max-width: 860px){
    .grid{ grid-template-columns: 1fr; }
    .actions{ justify-content: stretch; }
    .actions ctl-button{ width: 100%; }
  }

  /* hide slotted templates or misc */
  ::slotted([hidden]){ display:none !important; }
</style>

<div class="card" part="card">
  <div class="head" part="header">
    <div class="title" part="title"></div>
    <div class="sub" part="subtitle"></div>
  </div>

  <form id="form" part="form" novalidate>
    <div class="grid" part="grid">
      <ctl-form-field id="ffLocation" label="Location" hint="Enter ZIP or city">
        <ctl-text-field id="location" placeholder="e.g. 45202 or Cincinnati"></ctl-text-field>
      </ctl-form-field>

      <ctl-form-field id="ffDate" label="Move-in date" hint="Optional">
        <input id="moveIn" type="date" part="date" />
      </ctl-form-field>

      <ctl-form-field id="ffSize" label="Unit size" hint="Optional">
        <ctl-select id="size"></ctl-select>
      </ctl-form-field>
    </div>

    <div class="row" part="row">
      <div class="toggles" part="toggles">
        <label class="toggle">
          <input id="climate" type="checkbox" />
          Climate controlled
        </label>
        <label class="toggle">
          <input id="driveup" type="checkbox" />
          Drive-up access
        </label>
        <label class="toggle">
          <input id="promoOnly" type="checkbox" />
          Promotions only
        </label>
      </div>

      <div style="flex:1;"></div>

      <div class="actions" part="actions">
        <ctl-button id="btnClear" variant="secondary" type="button">Clear</ctl-button>
        <ctl-button id="btnSearch" type="submit">Search availability</ctl-button>
      </div>
    </div>

    <div class="errors" part="errors" aria-live="polite"></div>

    <slot name="extra"></slot>

    <div class="helper" part="helper">
      <slot name="helper">Prices and availability update in real time.</slot>
    </div>
  </form>

  <div class="foot" part="footer">
    <slot name="footer"></slot>
  </div>
</div>
`;

function safeJsonParse(str, fallback) {
  try { return JSON.parse(str); } catch { return fallback; }
}
function toArray(v){ return Array.isArray(v) ? v : []; }
function clampStr(s){ return String(s ?? "").trim(); }

export class CtlSearchAvailability extends HTMLElement {
  static get observedAttributes() {
    return ["title", "subtitle", "loading", "disabled", "sizes", "value"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));

    this._titleEl = this.shadowRoot.querySelector(".title");
    this._subEl = this.shadowRoot.querySelector(".sub");
    this._form = this.shadowRoot.getElementById("form");

    this._ffLocation = this.shadowRoot.getElementById("ffLocation");
    this._ffDate = this.shadowRoot.getElementById("ffDate");
    this._ffSize = this.shadowRoot.getElementById("ffSize");

    this._location = this.shadowRoot.getElementById("location");
    this._moveIn = this.shadowRoot.getElementById("moveIn");
    this._size = this.shadowRoot.getElementById("size");

    this._climate = this.shadowRoot.getElementById("climate");
    this._driveup = this.shadowRoot.getElementById("driveup");
    this._promoOnly = this.shadowRoot.getElementById("promoOnly");

    this._btnClear = this.shadowRoot.getElementById("btnClear");
    this._btnSearch = this.shadowRoot.getElementById("btnSearch");
    this._errors = this.shadowRoot.querySelector(".errors");

    this._sizes = [
      { value: "", label: "Any size" },
      { value: "5x5", label: "5×5 (small closet)" },
      { value: "5x10", label: "5×10 (walk-in closet)" },
      { value: "10x10", label: "10×10 (1 bedroom)" },
      { value: "10x15", label: "10×15 (2 bedrooms)" },
      { value: "10x20", label: "10×20 (car / 2–3 bedrooms)" }
    ];

    this._onSubmit = this._onSubmit.bind(this);
    this._onClear = this._onClear.bind(this);
    this._onChange = this._onChange.bind(this);
  }

  connectedCallback() {
    if (!this.hasAttribute("title")) this.setAttribute("title", "Find a unit");
    if (!this.hasAttribute("subtitle")) this.setAttribute("subtitle", "Search current availability and reserve online.");
    if (!this.hasAttribute("sizes")) this.setAttribute("sizes", JSON.stringify(this._sizes));

    // hydrate
    this._applySizesFromAttr();
    this._applyValueFromAttr();
    this._sync();

    this._form.addEventListener("submit", this._onSubmit);
    this._btnClear.addEventListener("click", this._onClear);

    // track changes for value reflection + clearing invalid state
    this.shadowRoot.addEventListener("input", this._onChange);
    this.shadowRoot.addEventListener("change", this._onChange);
    this.addEventListener("ctl-change", this._onChange);
  }

  disconnectedCallback() {
    this._form.removeEventListener("submit", this._onSubmit);
    this._btnClear.removeEventListener("click", this._onClear);
    this.shadowRoot.removeEventListener("input", this._onChange);
    this.shadowRoot.removeEventListener("change", this._onChange);
    this.removeEventListener("ctl-change", this._onChange);
  }

  attributeChangedCallback(name) {
    if (name === "sizes") this._applySizesFromAttr();
    if (name === "value") this._applyValueFromAttr();
    this._sync();
  }

  // ---- attributes / props ----
  get title(){ return this.getAttribute("title") || ""; }
  set title(v){ this.setAttribute("title", String(v ?? "")); }

  get subtitle(){ return this.getAttribute("subtitle") || ""; }
  set subtitle(v){ this.setAttribute("subtitle", String(v ?? "")); }

  get loading(){ return this.hasAttribute("loading"); }
  set loading(v){ v ? this.setAttribute("loading","") : this.removeAttribute("loading"); }

  get disabled(){ return this.hasAttribute("disabled"); }
  set disabled(v){ v ? this.setAttribute("disabled","") : this.removeAttribute("disabled"); }

  get sizes(){ return this._sizes; }
  set sizes(v){
    this._sizes = toArray(v).map((o) => ({
      value: String(o?.value ?? ""),
      label: String(o?.label ?? "")
    }));
    this.setAttribute("sizes", JSON.stringify(this._sizes));
    this._applySizesToSelect();
  }

  get value(){
    return this._readValue();
  }
  set value(v){
    const next = v && typeof v === "object" ? v : {};
    this.setAttribute("value", JSON.stringify(next));
    this._applyValueFromAttr();
  }

  // ---- internals ----
  _sync() {
    this._titleEl.textContent = this.title;
    this._subEl.textContent = this.subtitle;

    const dis = this.disabled || this.loading;
    // best-effort disabling: your ctl-text-field/select might reflect disabled attr
    this._location.toggleAttribute("disabled", dis);
    this._size.toggleAttribute("disabled", dis);
    this._moveIn.disabled = dis;

    this._climate.disabled = dis;
    this._driveup.disabled = dis;
    this._promoOnly.disabled = dis;

    this._btnClear.toggleAttribute("disabled", dis);

    // loading reflected to primary button
    this._btnSearch.toggleAttribute("loading", this.loading);
    this._btnSearch.toggleAttribute("disabled", dis);

    // aria-busy
    this._form.setAttribute("aria-busy", this.loading ? "true" : "false");
  }

  _applySizesFromAttr() {
    const parsed = safeJsonParse(this.getAttribute("sizes"), null);
    if (Array.isArray(parsed) && parsed.length) {
      this._sizes = parsed.map((o) => ({
        value: String(o?.value ?? ""),
        label: String(o?.label ?? "")
      }));
    }
    this._applySizesToSelect();
  }

  _applySizesToSelect() {
    // ctl-select in your kit uses "options" JSON; align with that
    this._size.setAttribute("options", JSON.stringify(this._sizes));
    // keep current value if possible
    if (!this._sizes.some((o) => o.value === (this._size.value || ""))) {
      this._size.value = "";
      this._size.setAttribute("value", "");
    }
  }

  _applyValueFromAttr() {
    const v = safeJsonParse(this.getAttribute("value"), {});
    if (!v || typeof v !== "object") return;

    if (v.location != null) this._location.value = String(v.location);
    if (v.moveIn != null) this._moveIn.value = String(v.moveIn);
    if (v.size != null) {
      this._size.value = String(v.size);
      this._size.setAttribute("value", String(v.size));
    }

    if (v.features && typeof v.features === "object") {
      this._climate.checked = !!v.features.climate;
      this._driveup.checked = !!v.features.driveup;
      this._promoOnly.checked = !!v.features.promoOnly;
    }

    this.removeAttribute("invalid");
    this._errors.innerHTML = "";
  }

  _readValue() {
    return {
      location: clampStr(this._location.value),
      moveIn: clampStr(this._moveIn.value),
      size: clampStr(this._size.value),
      features: {
        climate: !!this._climate.checked,
        driveup: !!this._driveup.checked,
        promoOnly: !!this._promoOnly.checked
      }
    };
  }

  _setErrors(messages) {
    const list = (messages || []).filter(Boolean);
    if (!list.length) {
      this.removeAttribute("invalid");
      this._errors.innerHTML = "";
      // clear field errors best-effort
      this._ffLocation?.removeAttribute("error");
      return;
    }

    this.setAttribute("invalid", "");
    this._errors.innerHTML = list.map((m) => `<div class="error">${m}</div>`).join("");

    // best-effort: put location error on the field
    this._ffLocation?.setAttribute("error", list[0]);
  }

  _validate(payload) {
    const errs = [];
    // Require location for now (zip/city). You can relax later for single-facility sites.
    if (!payload.location) errs.push("Enter a ZIP code or city.");
    // If moveIn present, ensure it's a valid date string (native input handles most)
    return errs;
  }

  _onChange() {
    // update value attribute for easy debugging / state sync (optional but helpful)
    const v = this._readValue();
    this.setAttribute("value", JSON.stringify(v));

    // clear invalid state as user types
    if (this.hasAttribute("invalid")) {
      const errs = this._validate(v);
      this._setErrors(errs);
    }

    // emit change for stateful parents
    this.dispatchEvent(new CustomEvent("ctl-change", {
      bubbles: true,
      composed: true,
      detail: { value: v }
    }));
  }

  _onClear() {
    if (this.disabled || this.loading) return;
    this._location.value = "";
    this._moveIn.value = "";
    this._size.value = "";
    this._size.setAttribute("value", "");
    this._climate.checked = false;
    this._driveup.checked = false;
    this._promoOnly.checked = false;

    this.removeAttribute("invalid");
    this._errors.innerHTML = "";
    this._ffLocation?.removeAttribute("error");

    const v = this._readValue();
    this.setAttribute("value", JSON.stringify(v));

    this.dispatchEvent(new CustomEvent("ctl-change", {
      bubbles: true,
      composed: true,
      detail: { value: v }
    }));
  }

  _onSubmit(e) {
    e.preventDefault();
    if (this.disabled || this.loading) return;

    const payload = this._readValue();
    const errs = this._validate(payload);
    this._setErrors(errs);

    if (errs.length) return;

    this.dispatchEvent(new CustomEvent("ctl-form-submit", {
      bubbles: true,
      composed: true,
      detail: { value: payload }
    }));
  }
}

customElements.define("ctl-search-availability", CtlSearchAvailability);
